// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBubbleExclamation = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M5 22l3-3h13V5H3v17zm2.172-5H19V7H5v12.172z" />,
    <path d="M11 8.5V13h2V8.5zm2 7.2v-2h-2v2z" />
  );
export default SvgIconBubbleExclamation;
